import React from 'react';
import classnames from 'classnames';
import CloseBold from '@wix/da-ds/pkg/Icons/CloseBold';
import CloseSmall from '@wix/da-ds/pkg/Icons/CloseSmall';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './CloseButton.scss';
export const CloseButton = ({ view = 'b5-1', href, onClick, iconSize, className, type, biData, 'aria-label': ariaLabel })=>/*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: classnames(s['root'], s[view], className),
        onClick: onClick,
        type: type,
        biData: biData,
        "aria-label": ariaLabel,
        href: href
    }, view === 'b5-2' ? /*#__PURE__*/ React.createElement(CloseSmall, {
        className: s['icon'],
        size: iconSize
    }) // I32A
     : /*#__PURE__*/ React.createElement(CloseBold, {
        className: s['icon'],
        size: iconSize
    }) // I32
    );
CloseButton.displayName = 'CloseButton';
export default CloseButton;
